import {Component, Inject, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {BytesFormatter} from '@twpub/shared/utils/bytes-formatter';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {VirtualFile} from '@twpub/core/models';
import {NGXLogger} from 'ngx-logger';
import {VirtualFileService} from '@twpub/core/services/virtual-file.service';
import {CdkScrollable} from '@angular/cdk/scrolling';

import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'pub-virtual-file-content-dialog',
  templateUrl: './virtual-file-content-dialog.component.html',
  styleUrls: ['./virtual-file-content-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatIcon, MatDialogActions, MatButton]
})
export class VirtualFileContentDialogComponent implements OnInit {
  contentUrl?: SafeResourceUrl;
  vfile?: VirtualFile;
  openLink: boolean = false;
  downloadLinkName?: string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: { vfile: VirtualFile, contentUrl?: string },
              private dialogRef: MatDialogRef<VirtualFileContentDialogComponent>,
              private logger: NGXLogger,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    const {vfile, contentUrl} = this.data;
    this.vfile = vfile;
    this.logger.debug('VirtualFileContentDialogComponent.ngOnInit:', {vfile})
    // contentUrl is a blob: URL fetched through the authenticated HttpClient (see AttachmentRenderWrapperComponent).
    this.contentUrl = contentUrl ? this.sanitizer.bypassSecurityTrustResourceUrl(contentUrl) : undefined;
    !this.isAudio() && this.setOpenInNewWindowLink();
  }

  getDisplayName(): string {
    const name = this.vfile?.name || '';
    const extension = this.vfile?.fileType ? `.${this.vfile.fileType}` : '';
    return `${name}${extension}`;
  }

  private setOpenInNewWindowLink() {
    const {size} = this.vfile!;
    this.openLink = this.isPdf() || this.isVideo();
    this.downloadLinkName = `Download ${this.getDisplayName()} (${BytesFormatter.formatBytes(size)})`;
  }

  isAudio = () => VirtualFileService.isAudio(this.vfile);
  isVideo = () => VirtualFileService.isVideo(this.vfile);
  isPdf = () => VirtualFileService.isPdf(this.vfile);
  isImage = () => VirtualFileService.isImage(this.vfile);

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
